import { BSHOrder, File, Layer, Order } from '../../../utils/models';
import { FormattedMessage } from 'react-intl';
import globalMessages from '../../../../config/globalMessages.js';
import { Sync } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

const dynamicCheckBoxStatuses = ['unconfirmed', 'planing/lks'];

const dynamicCheckBoxField = {
  ...BSHOrder.fields.dynamicCheckBox,
  format: {
    ...BSHOrder.fields.dynamicCheckBox.format,
    enableFunction: function (item) {
      const status = item?.status ?? '';

      return dynamicCheckBoxStatuses.some((enabledStatus) => status.includes(enabledStatus));
    }
  }
};

const orderFields = [
  // KVH
  { ...dynamicCheckBoxField, width: 0.3 },
  { ...BSHOrder.fields.id, width: 0.7 },
  { ...BSHOrder.fields.group, width: 0.5 },
  { ...BSHOrder.fields.pressId, width: 0.7 },
  { ...BSHOrder.fields.orderNumber, width: 1.0 },
  //{ ...BSHOrder.fields.assignedPress, width: 1 },
  { ...BSHOrder.fields.dimensionsConvertedLengthInFeet, width: 1.2 },
  //{ ...BSHOrder.fields.camberedRadius, width: 0.8 },
  //{ ...BSHOrder.fields.camber, width: 0.7 },
  //{ ...BSHOrder.fields.directionFournier, width: 0.9 },
  { ...BSHOrder.fields.status, width: 1.2 },
  //{ ...BSHOrder.fields.extraStatus, width: 1.2 },
  { ...BSHOrder.actions.editControlOrder, width: 0.5 },
  { ...BSHOrder.actions.deleteControlOrder, width: 0.5 },
  { ...BSHOrder.actions.moveOrderToDone, width: 0.5 },
  { ...BSHOrder.actions.moveUp, width: 0.5 },
  { ...BSHOrder.actions.moveDown, width: 0.5 },
  //{ ...BSHOrder.actions.printLabelFournier, width: 0.5 },
  { ...BSHOrder.fields.draggableArea, width: 0.7 }
];

const finishedOrderFields = [
  { ...BSHOrder.fields.id, width: 0.7 },
  { ...BSHOrder.fields.pressId, width: 0.7 },
  { ...BSHOrder.fields.smartlamOrderNumber, width: 0.7 },
  { ...BSHOrder.fields.assignedPress, width: 1.2 },
  { ...BSHOrder.fields.status, width: 1.5 },
  { ...BSHOrder.fields.layers },
  { ...BSHOrder.actions.printLabelFournier, width: 0.5 }
];

const scannedBeamsFields = [
  { ...BSHOrder.fields.id, width: 0.7 },
  { ...BSHOrder.fields.orderNumber, width: 0.7 },
  { ...BSHOrder.fields.gpaoId, width: 0.7 },
  { ...BSHOrder.fields.scannedAt, width: 0.7 },
  { ...BSHOrder.fields.rawBeamDimensions, width: 0.7 },
  { ...BSHOrder.fields.finalBeamDimensions, width: 0.7 },
  { ...BSHOrder.fields.useLKS, width: 0.7 },
  { ...BSHOrder.actions.deleteControlOrderScanned, width: 0.5 }
];

const layerFields = [
  { ...Layer.fields.id, width: 0.5 },
  { ...Layer.fields.layerNo, width: 0.2 },
  { ...Layer.fields.rawDimensionsConvertedLengthInFeet, width: 1 },
  { ...Layer.fields.lamellaDimensionsConverted, width: 0.8 },
  { ...Layer.fields.numOfLamellas, width: 0.4 },
  { ...Order.fields.layerLamellaLengths, width: 3.5 },
  // { ...Layer.fields.orderColor, width: 0.7 },
  { ...Layer.fields.useLKS, width: 0.5 },
  { ...Layer.actions.printLabelFournier, width: 0.5 }
];

const colorsOrder = function (item) {
  let color = '#FFFFFF';

  if (item.status === 'pressing') {
    color = 'rgba(119, 221, 119, 0.35)';
  } else if (item.status === 'planing/lks') {
    color = 'rgba(194, 148, 196, 0.35)';
  } else if (item.status === 'waiting for press') {
    color = '#FFCF9E';
  } else if (item.status === 'done') {
    color = 'rgba(24, 89, 41, 0.35)';
  } else if (item.status === 'jointing') {
    color = 'rgba(19, 101, 160, 0.35)';
  } else {
    color = '#FFFFFF';
  }

  return color;
};

const orders = [orderFields, finishedOrderFields];
const multipleOrderView = true;
const label = <FormattedMessage {...globalMessages.orders} identifier={'orders'} />;

const ordersList = {
  orderFields: {
    string: <FormattedMessage {...globalMessages.activeOrders} identifier={'activeOrders'} />,
    dataSet: orderFields,
    data: 'orderQueue'

    // colors: colorsOrder
  },
  finishedOrderFields: {
    string: <FormattedMessage {...globalMessages.finishedOrders} identifier={'finishedOrders'} />,
    dataSet: finishedOrderFields,
    data: 'lastFewOrdersPressed'
    // colors: colorsOrder
  }
};

const buttons = {
  syncOrders: {
    style: {},
    label: 'syncOrders',
    icon: <Sync />,
    action: 'sync-lastFewPressed-orders',
    dataSet: 'lastFewOrdersPressed'
  }
};

const checkedButtons = {
  removeOrders: {
    style: {},
    label: 'removeOrders',
    icon: <DeleteIcon />,
    action: 'remove-checked-orders',
    dataSet: 'orderQueue'
  },
  emergencyRequest: {
    style: {},
    label: 'emergencyRequest',
    icon: <PriorityHighIcon />,
    action: 'add-urgent-orders',
    modal: {
      modal: true,
      buttonText: 'emergencyRequest',
      key: 'emergencyRequest',
      action: 'emergencyRequest',
      icon: 'highPriority',
      modalText: 'Confirm emergency request?',
      actionData: {
        target: 'control',
        source: 'ordersqueue',
        identifier: 'emergency-order-request',
        items: 'selected',
        callType: 'POST'
      }
    },
    dataSet: 'orderQueue'
  }
};

const searchFilterOptions = [
  { value: 'id', label: <FormattedMessage id="id" defaultMessage="ID" /> },
  { value: 'pressId', label: <FormattedMessage id="pressId" defaultMessage="Press ID" /> }
];

export const wiehag_config = {
  orderFields,
  layerFields,
  orders,
  multipleOrderView,
  ordersList,
  colors: colorsOrder,
  label,
  buttons,
  checkedButtons,
  searchFilterOptions
};

export default wiehag_config;
